import { render, staticRenderFns } from "./GooglePlaceAutocomplete.vue?vue&type=template&id=2245d42d"
import script from "./GooglePlaceAutocomplete.vue?vue&type=script&lang=js"
export * from "./GooglePlaceAutocomplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "GooglePlaceAutocomplete.vue"
export default component.exports